import { RuntimeLink } from "../../../runtime/RendererRuntime";

type Props = {
  category: string;
  period: string;
  items: { title: string; subtitle?: string }[];
};

/** Statistical update card with category, period and item list. */
export function StatUpdateCard({ category, period, items }: Props) {
  return (
    <div className="rounded-md bg-white p-4 shadow-sm ring-1 ring-slate-200">
      <div className="flex items-center justify-between">
        <span className="text-[#34D98A] text-[16px] xl:text-[18px] leading-[127.5%] uppercase">
          {category}
        </span>
        <span className="normal-case text-[#B2B0B0] text-[16px] xl:text-[18px]">{period}</span>
      </div>
      <div className="mt-3 space-y-2 text-sm xl:text-base md:text-base">
        {items.map((it, i) => {
          let linkClasses = "block text-slate-600 hover:text-[#00A356]";
          if (i === 0) {
            linkClasses = "block text-[#00B862] text-[18px] xl:text-[20px] font-bold leading-[140%] mb-0";
          } else if (i === 1) {
            linkClasses = "block text-[#00B862] text-[18px] xl:text-[20px] font-bold leading-[140%]";
          }

          return (
            <RuntimeLink key={`${it.title}-${i}`} className={linkClasses} href="#">
              {it.title}
            </RuntimeLink>
          );
        })}
        <div className="flex items-center justify-between">
          <span className="text-[#B2B0B0] text-[16px] xl:text-[18px] leading-[140%] capitalize">
            Publication {period}
          </span>
          <span className="text-xs xl:text-sm md:text-sm text-slate-500">PDF</span>
        </div>
      </div>
    </div>
  );
}



